var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[(_vm.swapLogoSide)?_c('PowerBy',{attrs:{"isHeader":true}}):_vm._e(),_c('AffiliateLogo'),(!_vm.swapLogoSide)?_c('PowerByTestB',{attrs:{"isHeader":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }